<template>
  <div
    class="filters__section"
    :class="{
      'u-margin-bottom-none': enableSupplierFocusedSearch,
    }"
  >
    <FiltersInitial
      :APICall="APICall"
      :applyFiltersText="applyFiltersText"
      :applyFiltersToAPICall="applyFiltersToAPICall"
      :disableSubRegionDropdown="disableSubRegionDropdown"
      :deleteSubRegions="deleteSubRegions"
      :isTab2="isTab2"
      :locations="locations"
      :optionalExpanded="optionalExpanded"
      :selectedRegion="selectedRegion"
      :selectedSubRegions="selectedSubRegions"
      :subRegionsForRegion="subRegionsForRegion"
      :updateRegion="updateRegion"
      :updateShowOptions="updateShowOptions"
      :updateSubRegions="updateSubRegions"
    ></FiltersInitial>
    <div
      :class="[
        optionalExpanded
          ? 'filters__optional-filters'
          : 'filters__optional-filters filters__optional-filters--hidden utility-hidden',
      ]"
      :tabindex="[optionalExpanded ? '0' : '-1']"
      aria-label="Optional Filters"
    >
      <FiltersOptional
        :APICall="APICall"
        :applyFiltersText="applyFiltersText"
        :applyFiltersToAPICall="applyFiltersToAPICall"
        :clearAllFilters="clearAllFilters"
        :clearFiltersText="clearFiltersText"
        :culturalExperience="culturalExperience"
        :genders="genders"
        :languages="languages"
        :optionalExpanded="optionalExpanded"
        :removeFilterFromButton="removeFilterFromButton"
        :selectedCulturalExperience="selectedCulturalExperience"
        :selectedGenders="selectedGenders"
        :selectedLanguages="selectedLanguages"
        :selectedTherapistExperience="selectedTherapistExperience"
        :therapistExperience="therapistExperience"
        :updateFilterFromButton="updateFilterFromButton"
        :updateShowOptions="updateShowOptions"
      ></FiltersOptional>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FiltersInitial from "./FiltersInitial.vue";
import FiltersOptional from "./FiltersOptional.vue";

export default Vue.component("FiltersSection", {
  props: {
    APICall: Function,
    applyFiltersText: String,
    applyFiltersToAPICall: Function,
    clearAllFilters: Function,
    clearFiltersText: String,
    culturalExperience: Array,
    deleteSubRegions: Function,
    disableSubRegionDropdown: Boolean,
    enableSupplierFocusedSearch: Boolean,
    genders: Array,
    isTab2: Boolean,
    languages: Array,
    locations: Array,
    optionalExpanded: Boolean,
    removeFilterFromButton: Function,
    selectedCulturalExperience: Array,
    selectedGenders: Array,
    selectedLanguages: Array,
    selectedRegion: Array,
    selectedSubRegions: Array,
    selectedTherapistExperience: Array,
    subRegionsForRegion: Array,
    therapistExperience: Array,
    updateFilterFromButton: Function,
    updateRegion: Function,
    updateShowOptions: Function,
    updateSubRegions: Function,
  },
  components: {
    FiltersInitial,
    FiltersOptional,
  },
  data: function () {
    return {
      show: true,
    };
  },
});
</script>
